import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { Button } from "affinityUI/elements/button";
import { Grid } from "affinityUI/elements/grid";
import { Input } from "affinityUI/form/inputs/input";

export const PatientSearch: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const term = searchParams.get("term");
  const [value, setValue] = useState<Maybe<string>>(null);

  const handleChange = useCallback((e) => {
    setValue(e.target.value);
  }, []);

  const handleSearch = useCallback(
    (e) => {
      e.preventDefault();
      navigate("/patients/search?term=" + value);
    },
    [navigate, value]
  );

  useEffect(() => {
    setValue(term ?? "");
  }, [term]);

  return (
    <form onSubmit={handleSearch}>
      <Grid $tight $cols={[4, 1]}>
        <Input
          data-testid="search-input"
          placeholder="Search by Name, Hospital / NHS Number or ID"
          value={value ?? ""}
          onChange={handleChange}
          name="search"
        />
        <Button data-testid="search-submit" type="submit">
          Search
        </Button>
      </Grid>
    </form>
  );
};
